import request from '@/utils/request'

let ProfessionApi = {

  /*工种列表*/
  list(data) {
    return request._post('/shop/plus.profession.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.profession.Index/indexx', data);
},
/*添加工种*/
add(data) {
    return request._post('/shop/plus.profession.Index/add', data);
},
/*修改工种*/
edit(data) {
    return request._post('/shop/plus.profession.Index/edit', data);
},
/*删除工种*/
del(data) {
    return request._post('/shop/plus.profession.Index/del', data);
},
/*工种详情*/
detail(data) {
  return request._post('/shop/plus.profession.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.profession.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.profession.Setting/getSetting', data, errorback);
    },
}
export default ProfessionApi;



// WEBPACK FOOTER //
// ./src/api/profession.js